export const categoryGroups = [
  {
    id: 'cat-movie',
    label: '电影',
    intro: '院线新片与独立佳作，正片上线即整理，附片长与看点提示。',
    items: ['雾港迷航', '第七个夏天', '回声谷', '霓虹之后'],
  },
  {
    id: 'cat-series',
    label: '剧集',
    intro: '长短剧集按更新节奏整理，标注集数与当前进度，方便追更。',
    items: ['长风渡口', '城中之城·夜航', '半城烟火'],
  },
  {
    id: 'cat-anime',
    label: '动漫',
    intro: '原创与新番分区整理，含合家欢方向作品，适合全年龄浏览。',
    items: ['星轨旅人', '蓝莓小镇奇遇'],
  },
  {
    id: 'cat-variety',
    label: '综艺',
    intro: '慢综艺与美食类节目，按期次整理，周末放松首选。',
    items: ['周末野餐计划', '一起来做菜吧'],
  },
  {
    id: 'cat-doc',
    label: '纪实',
    intro: '美食人文与自然题材纪录片，适合慢慢看的深度内容。',
    items: ['山与海的餐桌'],
  },
];

export const watchGuide = [
  {
    id: 'guide-01',
    step: '01',
    title: '先看今日更新速递',
    desc: '首屏「今日更新」按时间倒序排出最新上线的条目，包含类型、进度与一句话说明，几秒钟就能确认有没有你在追的内容。',
  },
  {
    id: 'guide-02',
    step: '02',
    title: '用标签筛出想看的类型',
    desc: '在「热门新片」区切换电影、剧集、动漫、综艺、纪实标签，卡片会立刻按类型收窄，无需跳转其他页面。',
  },
  {
    id: 'guide-03',
    step: '03',
    title: '对齐更新节奏再追更',
    desc: '「全集与追更专区」会标出总集数与当前进度，完结作品可以直接连续看，连载作品则可按更新频率安排时间。',
  },
  {
    id: 'guide-04',
    step: '04',
    title: '参考热度榜挑片',
    desc: '不确定看什么时，先看热度榜前十。榜单按浏览热度排序，并标注趋势，能快速找到近期讨论度高的作品。',
  },
];

export const siteStats = [
  { id: 'stat-01', value: '1,280+', label: '在库条目' },
  { id: 'stat-02', value: '每日', label: '更新频率' },
  { id: 'stat-03', value: '9', label: '内容分类' },
  { id: 'stat-04', value: '10 万+', label: '月浏览人次' },
];